<template>
  <el-dialog title="参照历史检测数据" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false" :before-close="handleClose" class="reference-dialog">
    <!-- 搜索条件区域 -->
    <div class="search-section">
      <el-form :model="searchForm" :inline="true" size="small" label-width="100px">
        <el-form-item label="使用单位">
          <el-input v-model="searchForm.USE_UNT_NAME" placeholder="请输入使用单位" clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="小区名称">
          <el-input v-model="searchForm.projectName" placeholder="请输入小区名称" clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="searchForm.EQP_NAME" placeholder="请输入设备名称" clearable style="width: 160px"></el-input>
        </el-form-item>
        <el-form-item label="识别码">
          <el-input v-model="searchForm.oidNo" placeholder="请输入识别码" clearable style="width: 160px"></el-input>
        </el-form-item>
        <el-form-item label="到检年月">
          <el-date-picker v-model="searchForm.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 180px"></el-date-picker>
        </el-form-item>
        <div style="text-align: center;">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </div>
      </el-form>
    </div>

    <!-- 列表区域 -->
    <div class="table-section">
      <el-table ref="dataTable" v-loading="loading" :data="tableData" border stripe style="width: 100%" :height="400">
        <el-table-column width="30" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectedRowIndex" :label="scope.$index" @change="handleRadioChange(scope.row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="EQP_TEMP_NAME" label="设备名称" min-width="180" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="EQP_STATION_COD" label="设备代码" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="EQP_REG_COD" label="注册代码" min-width="150" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="OIDNO" label="识别码" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="inspectionMonth" label="到检年月" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="FACTORY_COD" label="产品编号" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="EQP_INNER_COD" label="内部编号" min-width="120" show-overflow-tooltip></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pagination.currPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                       :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" :disabled="!selectedRow">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { querySavedTestDataList, copyReportTestDataInfo } from '@/api/contract/contract'

export default {
  name: 'ReferenceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 从父组件传入的默认使用单位
    defaultUseUntName: {
      type: String,
      default: ''
    },
    // 从父组件传入的默认设备名称
    defaultEqpName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      searchForm: {
        USE_UNT_NAME: '',
        projectName: '',
        EQP_NAME: '',
        oidNo: '',
        factoryCod: '',
        inspectionMonthList: []
      },
      tableData: [],
      selectedRow: null, // 当前选中的行
      selectedRowIndex: null, // 当前选中的行索引
      pagination: {
        currPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        // 弹窗打开时，设置默认使用单位和设备名称并查询
        this.searchForm.USE_UNT_NAME = this.defaultUseUntName
        this.searchForm.EQP_NAME = this.defaultEqpName
        this.handleSearch()
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    // 查询数据
    handleSearch () {
      this.pagination.currPage = 1
      this.loadData()
    },
    // 重置搜索条件
    handleReset () {
      this.searchForm = {
        USE_UNT_NAME: this.defaultUseUntName,
        projectName: '',
        EQP_NAME: this.defaultEqpName,
        oidNo: '',
        factoryCod: '',
        inspectionMonthList: []
      }
      this.handleSearch()
    },
    // 加载数据
    async loadData () {
      this.loading = true
      try {
        const params = {
          currPage: this.pagination.currPage,
          pageSize: this.pagination.pageSize,
          USE_UNT_NAME: this.searchForm.USE_UNT_NAME || '',
          projectName: this.searchForm.projectName || '',
          EQP_NAME: this.searchForm.EQP_NAME || '',
          oidNo: this.searchForm.oidNo || '',
          factoryCod: this.searchForm.factoryCod || '',
          inspectionMonthList: this.searchForm.inspectionMonthList || []
        }

        const response = await querySavedTestDataList(params)

        if (response && response.retCode == "ok") {
          this.tableData = response.additionalData.records || []
          this.pagination.total = response.additionalData.total || 0
        } else {
          this.$message.error(response.message || '查询失败')
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('查询数据失败:', error)
        // this.$message.error('查询数据失败，请稍后重试')
        this.tableData = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    // 单选框改变事件
    handleRadioChange (row) {
      this.selectedRow = row
    },
    // 表格行选中事件（保留但不再使用）
    handleCurrentChange (currentRow) {
      // 不再使用此方法
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.pagination.currPage = 1
      this.loadData()
    },
    // 页码改变
    handlePageChange (val) {
      this.pagination.currPage = val
      this.loadData()
    },
    // 确认按钮
    async handleConfirm () {
      if (!this.selectedRow) {
        this.$message.warning('请先选择一条数据')
        return
      }

      // 获取选中行的委托编号和首检年份
      const entrustNum = this.selectedRow.entrustNum || this.selectedRow.ENTRUST_NUM
      const firstDate = this.selectedRow.FIRST_YEAR

      if (!entrustNum) {
        this.$message.error('选中数据缺少委托编号')
        return
      }

      try {
        this.loading = true
        // 构建请求URL，添加 firstDate 参数
        let url = entrustNum

        const response = await copyReportTestDataInfo(url)

        if (response && response.retCode == 'ok') {
          console.log('=== 参照数据返回 ===')
          console.log('委托编号:', entrustNum)
          console.log('首检年份:', firstDate)
          console.log('返回数据:', response.additionalData)
          console.log('==================')

          // 将数据传递给父组件（回填过程由父页面 loading 遮罩承接）：
          // 1) rptTestDataInfos -> datas（检测项与附表明细）
          // 2) testData 平铺到顶层（设备/封面等字段），便于 RecordDialog 现有 fillFormData 直接回填
          // 3) 保留 infoList/elevSettingData 等其余结构
          const ad = response.additionalData || {}
          const { rptTestDataInfos, elevSettingData, testData, ...restFromAdditional } = ad

          // 兼容后端 testData 的多种返回形态：
          // 1) 对象；2) JSON 字符串；3) 数组（取首个对象）
          let flatTestData = {}
          if (testData && typeof testData === 'object' && !Array.isArray(testData)) {
            flatTestData = testData
          } else if (typeof testData === 'string') {
            try {
              const parsed = JSON.parse(testData)
              if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                flatTestData = parsed
              } else if (Array.isArray(parsed) && parsed[0] && typeof parsed[0] === 'object') {
                flatTestData = parsed[0]
              }
            } catch (e) {
              console.warn('testData 解析失败，回退到 additionalData 顶层字段:', e)
            }
          } else if (Array.isArray(testData) && testData[0] && typeof testData[0] === 'object') {
            flatTestData = testData[0]
          }

          // 结论字段兜底（不同接口版本字段命名可能不一致）
          if (flatTestData.testConclusion == null && restFromAdditional.testConclusion != null) {
            flatTestData.testConclusion = restFromAdditional.testConclusion
          }
          if (flatTestData.testConclusionDesc == null && restFromAdditional.testConclusionDesc != null) {
            flatTestData.testConclusionDesc = restFromAdditional.testConclusionDesc
          }
          if (flatTestData.testConclusion == null && restFromAdditional.reportConclusion != null) {
            flatTestData.testConclusion = restFromAdditional.reportConclusion
          }
          if (flatTestData.testConclusionDesc == null && restFromAdditional.reportConclusionDesc != null) {
            flatTestData.testConclusionDesc = restFromAdditional.reportConclusionDesc
          }
          // 参照数据中的 null/undefined 不参与回填，避免覆盖页面已有初始化值
          const flatTestDataWithoutNull = Object.keys(flatTestData).reduce((acc, key) => {
            if (flatTestData[key] != null) {
              acc[key] = flatTestData[key]
            }
            return acc
          }, {})
          this.$emit('referenceConfirm', {
            ...restFromAdditional,
            ...flatTestDataWithoutNull,
            datas: Array.isArray(rptTestDataInfos) ? rptTestDataInfos : [],
            elevSettingData: elevSettingData || null
          })

          // 关闭弹窗
          this.handleClose()
        } else {
          this.$message.error(response.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取参照数据失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    // 关闭弹窗
    handleClose () {
      this.dialogVisible = false
      this.selectedRow = null
      this.selectedRowIndex = null
      this.$refs.dataTable && this.$refs.dataTable.setCurrentRow()
    }
  }
}
</script>

<style scoped >
.reference-dialog .search-section {
  padding: 10px 0;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 15px;
}

.reference-dialog .table-section {
  margin-bottom: 15px;
}

.reference-dialog .pagination-section {
  margin-top: 15px;
  text-align: right;
}

.reference-dialog .dialog-footer {
  text-align: right;
}
</style>
el-form-item>